import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SixMp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14h1.5v1.5H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18V3H3zm7 2.5h4.5V7h-3v1h3v3.5H10v-6zm2.5 13H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5v6zM18 17h-3v1.5h-1.5v-6H18V17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9H13v1.5h-1.5z"
  }));
});
SixMp.displayName = 'SixMp';
export var SixMpDimensions = {
  height: 24,
  width: 24
};